module.exports = __webpack_public_path__ + "static/media/UnderWater.06380ef8.jpeg";